import { useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { getTheme, Theme } from '../../ui/theme';
import Header from './Header';
import Menu from './Menu';

export default function Overlay() {
    const [theme,] = useState<Theme>(getTheme);
    return (
        <ThemeProvider theme={theme}>
            <Header />
            <Menu />
        </ThemeProvider>
    )
}